import React, { useCallback, useRef, useState } from 'react';

import moment from "moment";
import { SlicedText } from '../messagesP';
import { HtmlTooltip } from '../messages';
import { NumericFormat } from 'react-number-format';

export const IconAndTitle = ({icon, title, size}) => {
    return (
        <div className='info-and-image'>
            <img src={icon} alt="Icon"/>
            <SlicedText type={'name'} size={size ? size : 10} data={title}/>
        </div>
    )
}

export const IdRow = ({id}) => {
    return (
        <SlicedText type={'id'} size={10} data={id}/>
    )
}

export const DateRow = ({date}) => {
    return (
        moment.utc(date).format('MM/DD/YYYY')
    )
}

export const NameRow = ({name, size, big}) => {
    return (
        <SlicedText type={'bigText'} size={20} data={name ? name : 'Not Set'}/>
    )
}

export const EmailRow = ({name, size}) => {
    return (
        <SlicedText type={'email'} size={size ? size : 20} data={name ? name : 'Not Set'}/>
    )
}

export const AddressRow = ({name, size}) => {
    return (
        <SlicedText type={'address'} size={size ? size : 30} data={name ? name : 'Not Set'}/>
    )
}

export const PhoneRow = ({phone}) => {
    return (
        `+${phone}`
    )
}

export const TypeRow = ({text}) => {
    return (
        text.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
            return g1.toUpperCase() + g2.toLowerCase();
        })
    )
}
export const TextRow = ({name, textWidth, width, color}) => {
    const ref = useRef()
    const text = (name ? name : 'Not Set') + ''
    const currentWidth = width ? width : ref?.current?.offsetWidth ? ref?.current?.offsetWidth : 200
    return (
        <div ref={ref}>{RenderText(currentWidth, text, textWidth, color)}</div>
    )
}

export function formatNumberToFix(num) {
    const fixed3 = num.toFixed(2); // always 3 decimals
    if (fixed3[fixed3.length - 1] === '0') {
        // if 3rd decimal is 0 → show 2 decimals
        return num.toFixed(2);
    }
    return fixed3; // otherwise keep 3 decimals
}


export const PriceRow = ({ info, textWidth }) => {
    const [currentWidth, setCurrentWidth] = useState(null);

    const curr = useCallback(node => {
        if (node !== null) {
            setCurrentWidth(node.getBoundingClientRect().width);
        }
    }, []);

    const width = currentWidth ? currentWidth : 250;

    // const price = (info ? info.toFixed(3) : 0) + '';
    const price =
        info === 0 ? '0.00' :
            (info ? formatNumberToFix(info) : 0.00) +
            '';

    if (price) {
        const count = Math.ceil(width / (textWidth ? textWidth : 11));
        const slicedText = '' + price?.slice(0, count);

        return <div ref={curr} className="text-style">
            {price?.length > count ?
                <HtmlTooltip
                    title={
                        <p>
                            <NumericFormat value={price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                        </p>
                    }
                    placement="top-start"
                >
                    <p style={{ textOverflow: 'ellipsis' }}>
                        <NumericFormat value={slicedText} displayType={'text'} thousandSeparator={true} prefix={'$'} />...
                    </p>
                </HtmlTooltip>
                :
                <p>{
                    <NumericFormat value={price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                }</p>
            }
        </div>;
    } else {
        return '...';
    }
};


const RenderText = (width, text, textWidth,color) => {
    if (text) {

        const count = Math.ceil(width / (textWidth ? textWidth : 11))
        const slicedText = '' + text?.slice(0, count)
        return <div className='text-style' style={color ? {color:color}: {}}>
            {text?.length > count ?
                <HtmlTooltip
                    title={<p>{text}</p>}
                    placement="top-start"
                >
                    <p style={{textOverflow: 'ellipsis',}}>
                        {`${slicedText}...`}
                    </p>
                </HtmlTooltip>
                :
                <p>{text}</p>
            }
        </div>
    } else {
        return '...'
    }
}